export default __webpack_public_path__ + "static/media/stolen.39f7e88d.png";